import { testimonials } from '../../data/content';

export default function Testimonials() {
  return (
    <section className="section bg-white">
      <div className="container-wide">
        <div className="text-center mb-16">
          <span className="inline-block text-sm font-semibold text-primary uppercase tracking-wider mb-3">
            Testimonials
          </span>
          <h2 className="text-headline text-text mb-4">
            Trusted by Industry Leaders
          </h2>
          <p className="text-text-light max-w-2xl mx-auto">
            See what our clients say about working with GAAS Analytical.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="group card p-8 border border-gray-100 hover:border-primary/20 relative overflow-hidden transition-all duration-300"
            >
              {/* Quote decoration */}
              <div className="absolute -top-4 -left-4 w-24 h-24 bg-primary-50 rounded-full opacity-50 group-hover:scale-150 transition-transform duration-500" />

              <div className="relative">
                {/* Quote mark */}
                <svg
                  className="w-10 h-10 text-primary/20 mb-4"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
                </svg>

                <p className="text-text-light leading-relaxed mb-6 italic">
                  "{testimonial.quote}"
                </p>

                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-gradient-to-br from-primary to-primary-600 rounded-full flex items-center justify-center text-white font-semibold text-sm">
                    {testimonial.author.split(' ').map(n => n[0]).join('')}
                  </div>
                  <div>
                    <p className="font-semibold text-text text-sm">
                      {testimonial.author}
                    </p>
                    <p className="text-primary text-sm font-medium">
                      {testimonial.company}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
